import { propertyStatusService } from '@/services/api/propertyStatus.service';
import i18n from '@/i18n';
import { sharedHelper, alertHelper } from '@/utils';
import { propertyStatusModel } from '@/models/api/propertyStatus.model';

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        },
    },
    details: {},
    status: {
        list: true,
        detail: true,
        save: true,
    },
};

export const PROPERTY_STATUS_MODULE = "api/propertyStatus";

// ACTIONS
export const GET_ALL_PROPERTY_STATUS = 'getAllPropertyStatus';
export const CREATE_PROPERTY_STATUS = 'createPropertyStatus';
export const GET_PROPERTY_STATUS = 'getPropertyStatus';
export const UPDATE_PROPERTY_STATUS = 'updatePropertyStatus';
export const UPDATE_PROPERTY_STATUS_SEQUENCE = 'updatePropertyStatusSequence';
export const UPDATE_PROPERTY_STATUS_STATUS = 'updatePropertyStatusStatus';

// MUTATIONS
const REQUESTING = "requesting";
const ALL_PROPERTY_STATUS_SUCCESS = "allPropertyStatusSuccess";
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const GET_PROPERTY_STATUS_SUCCESS = "getPropertyStatusSuccess";

export const actions = {
    [GET_ALL_PROPERTY_STATUS]({commit}, {filter}) {
        commit(REQUESTING, 'list');
        return propertyStatusService
            .getAll(filter)
            .then((result) => {
                commit(ALL_PROPERTY_STATUS_SUCCESS, {data: result});
                commit(SUCCESS);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [CREATE_PROPERTY_STATUS]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyStatusService
            .store(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.createX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_STATUS, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [GET_PROPERTY_STATUS]({commit}, {uuid}) {
        commit(REQUESTING, 'detail');
        return propertyStatusService
            .show(uuid)
            .then((result) => {
                commit(SUCCESS);
                commit(GET_PROPERTY_STATUS_SUCCESS, result);
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
    [UPDATE_PROPERTY_STATUS]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyStatusService
            .update(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_STATUS, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PROPERTY_STATUS_SEQUENCE]({commit, dispatch}, {data, filter}) {
        commit(REQUESTING, 'save');
        return propertyStatusService
            .updateSequence(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t('label.updateX', [i18n.t('message.success')])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_STATUS, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);

            });
    },
    [UPDATE_PROPERTY_STATUS_STATUS]({dispatch, commit}, {filter, data}) {
        commit(REQUESTING, 'save');
        return propertyStatusService
            .updateStatus(data)
            .then((result) => {
                alertHelper.alertSuccess({message: i18n.t(`${data.isActive==0 ? 'message.deleteXSuccess' : 'message.restoreXSuccess'}`, [])});
                commit(SUCCESS);
                dispatch(GET_ALL_PROPERTY_STATUS, {filter});
                return result;
            })
            .catch((error) => {
                alertHelper.alertError({
                    message: sharedHelper.getErrorMessage(error),
                    title: i18n.t('message.error'),
                });
                commit(FAILURE);
            });
    },
};


export const mutations = {
    [ALL_PROPERTY_STATUS_SUCCESS](state, {data}) {
        let propertyStatusList = data.data || [];
        state.list.data = propertyStatusList;
        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination);

        if(data.success) {
            state.list.data = propertyStatusList.map(item => propertyStatusModel(item));
        }
    },
    [GET_PROPERTY_STATUS_SUCCESS](state, data) {
        state.details = propertyStatusModel(data.data);
    },
    [FAILURE](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
    [REQUESTING](state, type) {
        state.status[type] = false;
    },
    [SUCCESS](state) {
        state.status = {
            list: true,
            detail: true,
            save: true,
        };
    },
};
